import React from 'react';
import { motion } from 'framer-motion';
import { workProcess } from '../data/mockData';
import { useLang } from '../context/LanguageContext';

const t = {
  fr: {
    label: 'Notre Méthode',
    h2a: 'Comment nous',
    h2b: 'travaillons ensemble',
    sub: 'Un processus clair et humain, pensé pour créer des résultats exceptionnels.',
  },
  en: {
    label: 'Our Method',
    h2a: 'How we',
    h2b: 'work together',
    sub: 'A clear and human process, designed to create exceptional results.',
  },
};

const ProcessSection = () => {
  const { lang } = useLang();
  const tx = t[lang];
  const steps = workProcess[lang];

  return (
    <section className="relative py-24 md:py-32 bg-[#f5f5f0]">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-5xl mx-auto mb-16 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-6">
            <span className="text-sm uppercase tracking-widest text-[#717171] font-mono">{tx.label}</span>
          </motion.div>
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#151515] mb-6 leading-tight">
            {tx.h2a}<br /><span className="text-[#4a5d6c]">{tx.h2b}</span>
          </motion.h2>
          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.4 }} className="text-lg md:text-xl text-[#151515]/60 max-w-3xl mx-auto">
            {tx.sub}
          </motion.p>
        </div>

        <div className="max-w-6xl mx-auto space-y-8 md:space-y-12">
          {steps.map((step, index) => (
            <motion.div key={step.id} initial={{ opacity: 0, x: index % 2 === 0 ? -60 : 60 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8, delay: index * 0.12, ease: "easeOut" }} whileHover={{ scale: 1.02, transition: { duration: 0.3 } }} className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
              <div className="flex-shrink-0">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gradient-to-br from-[#4a5d6c] to-[#1a3a52] flex items-center justify-center shadow-lg">
                  <span className="text-3xl md:text-4xl font-bold text-white">{step.step}</span>
                </div>
              </div>
              <div className="flex-1 bg-white rounded-2xl p-8 md:p-10 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-2xl md:text-3xl font-semibold text-[#151515] mb-4">{step.title}</h3>
                <p className="text-base md:text-lg text-[#151515]/70 leading-relaxed">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-3/4 bg-gradient-to-b from-[#4a5d6c]/20 via-[#1a3a52]/20 to-transparent hidden md:block -z-10" />
      </div>
    </section>
  );
};

export default ProcessSection;
